<template>
  <header class="header">
    <!--1A: Portal header -->
    <div class="portal-header portal-header-compact">
      <div class="container portal-header-inner">
        <AppIcon />
        <h1 :style="configStore.headlineStyle">Statens Administrative Stamdata</h1>
        <button
          class="function-link button-menu-open js-menu-open ml-auto d-print-none"
          aria-haspopup="menu"
          title="Åben mobil menu"
        >
          <svg class="icon-svg" focusable="false" aria-hidden="true">
            <use xlink:href="#menu" />
          </svg>
          Menu
        </button>

        <!-- 1B: Portal header: info + actions-->
        <div class="portal-info">
          <p class="user">
            <strong class="username weight-semibold">{{
              profileStore.user.userName
            }}</strong>
            <br />
            {{ profileStore.user.organizationName }}
          </p>
          <router-link
            v-if="
              profileStore.isAuthenticated &&
              profileStore.user.email.includes('kundedemo')
            "
            class="button button-secondary button-sm alert-leave d-print-none"
            to="/logout"
          >
            Log af
          </router-link>
        </div>
      </div>
    </div>

    <div class="overlay"></div>
    <nav class="nav">
      <!-- collapsible-->
      <button
        class="function-link button-menu-close js-menu-close"
        title="Luk mobil menu"
      >
        <svg class="icon-svg" aria-hidden="true">
          <use xlink:href="#close"></use>
        </svg>
        Luk
      </button>

      <!-- 3: Main navigation-->
      <div class="navbar navbar-primary">
        <!--3A: Main navigation-->
        <div class="navbar-inner container">
          <ul class="nav-primary">
            <router-link to="/regnskabsstruktur" custom v-slot="{ navigate }">
              <li
                @click="navigate"
                :class="{ current: $route.path === '/regnskabsstruktur' }"
              >
                <a href="#" class="nav-link">
                  <span role="link">Regnskabsstruktur</span>
                </a>
              </li>
            </router-link>
            <router-link to="/kontoplan" custom v-slot="{ navigate }">
              <li
                @click="navigate"
                :class="{ current: $route.path === '/kontoplan' }"
              >
                <a href="#" class="nav-link">
                  <span role="link">Kontoplan</span>
                </a>
              </li>
            </router-link>
            <router-link to="/finanslovsstruktur" custom v-slot="{ navigate }">
              <li
                @click="navigate"
                :class="{ current: $route.path === '/finanslovsstruktur' }"
              >
                <a href="#" class="nav-link">
                  <span role="link">Finanslovsstruktur</span>
                </a>
              </li>
            </router-link>

            <router-link
              to="/create-element-overview"
              custom
              v-slot="{ navigate }"
            >
              <li
                @click="navigate"
                :class="{ current: $route.path === '/create-element-overview' }"
              >
                <a href="#" class="nav-link">
                  <span role="link">Opret nyt element</span>
                </a>
              </li>
            </router-link>
            <router-link
              v-if="hasAccessToProcessTab"
              to="/processoverview"
              custom
              v-slot="{ navigate }"
            >
              <li
                @click="navigate"
                :class="{ current: $route.path === '/processoverview' }"
              >
                <a href="#" class="nav-link">
                  <span role="link">Processtyring</span>
                </a>
              </li>
            </router-link>
            <router-link to="/perioder" custom v-slot="{ navigate }">
              <li
              @click="navigate"
                :class="{ current: $route.path === '/perioder' }"
              >
                <a href="#" class="nav-link">
                  <span role="link">Perioder</span>
                </a>
              </li>
            </router-link>
            <router-link
              v-if="hasAccessKontobroerTab"
              to="/kontobroer"
              custom
              v-slot="{ navigate }"
            >
              <li @click="navigate" :class="{ current: $route.path === '/kontobroer' }">
                <a href="#" class="nav-link">
                  <span role="link">Kontobroer</span>
                </a>
              </li>
            </router-link>
            <router-link
              v-if="hasAccessActivitiesTab"
              to="/aktiviteter"
              custom
              v-slot="{ navigate }"
            >
              <li @click="navigate" :class="{ current: $route.path === '/aktiviteter' }">
                <a href="#" class="nav-link">
                  <span role="link">Aktiviteter</span>
                </a>
              </li>
            </router-link>
            <router-link
              v-if="hasAccessLoengrupperTab"
              to="/loengrupper"
              custom
              v-slot="{ navigate }"
            >
              <li
                @click="navigate"
                :class="{
                  current: $route.path === '/loengrupper',
                }"
              >
                <a href="#" class="nav-link">
                  <span role="link">Løngrupper</span>
                </a>
              </li>
            </router-link>
          </ul>
        </div>
      </div>
      <!-- 3: Main navigation end-->
    </nav>
    <!-- collapsible nav end-->
  </header>
</template>

<script setup lang="ts">
import AppIcon from "@/components/layouts/AppIcon.vue";
import { useConfigStore } from "@/stores/config";
import { useProfileStore } from "@/stores/profile";
import { computed } from "vue";

const profileStore = useProfileStore();
const configStore = useConfigStore();

//Users with either SADAProcesStyring, SADARettighederNiveau1, SADARettighederNiveau2 orSADARettighederAlle
//can see or click processoverview tab
const hasAccessToProcessTab = computed(() => {
  return profileStore.accessibleCommand?.hasAccessToProcessTab;
});
const hasAccessActivitiesTab = computed(() => {
  return profileStore.accessibleCommand?.hasAccessActivitiesTab;
});
const hasAccessLoengrupperTab = computed(() => {
  return profileStore.accessibleCommand?.hasAccessLoengrupperTab;
});
const hasAccessKontobroerTab = computed(() => {
  return profileStore.accessibleCommand?.hasAccessKontobroerTab;
});
</script>

<style lang="scss" scoped>
.oes-logo {
  background-image: url(../../../src/assets/oes_logo_rgb_dk.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center left;
  display: inline-block;
  height: 60px;
  width: 200px;
  max-width: 60%;
}
</style>
